import { useEffect, useState } from 'react'
import mapboxgl from 'mapbox-gl/dist/mapbox-gl'
import MapboxWorker from 'mapbox-gl/dist/mapbox-gl-csp-worker'

mapboxgl.workerClass = MapboxWorker

export const useMap = ({ ref, config, accessToken = process.env.MAPBOX_ACCESS_TOKEN }) => {
  const [map, setMap] = useState()
  useEffect(() => {
    mapboxgl.accessToken = accessToken

    const map = new mapboxgl.Map({
      container: ref.current,
      ...config,
    })

    setMap(map)
  }, [])

  return { map }
}
